/*
*
* FOOTER JS
*
*/

function revealElementsFooter() {

    initReveal('.community-troc .section-heading', {
        delay: 200,
        useDelay: 'onload',
        interval: 150,
        reset: false,
        distance: '10px',
        origin: 'bottom',
        easing: 'ease'
    });

    initReveal('.troc-community li', {
        delay: 100,
        useDelay: 'once',
        interval: 100,
        reset: false,
        distance: '10px',
        origin: 'bottom',
        easing: 'ease-out',
        viewOffset: {
            top: -100,
            right: -350,
            bottom: 0,
            left: 0,
        }
    });
}

$(document).ready(function() {

    revealElementsFooter();
});
